import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Alert extends VuexModule {
  public alertMessage: any = null;
  public typeMessage: any = null;

  get getAlertMessage(): any {
    return {
      message: this.alertMessage,
      type: this.typeMessage,
    };
  }

  @Mutation
  public MutationSetAlertMessage(input: any) {
    this.alertMessage = input.alertMessage ? input.alertMessage : null;
    this.typeMessage = input.typeMessage;
  }

  @Mutation
  public MutationClearAlertMessage() {
    this.alertMessage = null;
    this.typeMessage = null;
  }

  @Action
  public SetAlertMessage(input: any) {
    setTimeout(() => {
      this.context.commit("MutationSetAlertMessage", input);
    }, 50);
  }

  @Action
  public ClearAlertMessage() {
    this.context.commit("MutationClearAlertMessage");
  }
}
